export const getTrendChange = (value: number, prevValue: number) => {
  const diff = value - prevValue;
  const percentChange = diff === 0 ? 0 : (diff / prevValue) * 100;
  if (Math.abs(percentChange) < 1) {
    return Number(percentChange.toFixed(2));
  } else {
    return Math.round(percentChange);
  }
};
